import BMenuItem from '../menu/menu-item'

/* istanbul ignore next */
BMenuItem.install = function (Vue) {
  Vue.component(BMenuItem.name, BMenuItem)
}

export default BMenuItem
